import apiClient from "../../../utils/clients/axios";

export const MaterialOutwardEntry = async (payload) => {
  const response = await apiClient.post("/materialinward/", payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response;
};

export const getMaterialOutwardData = async () => {
  const { data } = await apiClient.get("/materialoutward/queue/");

  console.log({ data });

  return data;
};

export const updateMaterialOutwardStatus = async (id) => {
  const response = await apiClient.patch(`/materialoutward?id=${id}`, {
    status: "OUT",
  });

  return response;
};

export const createBarcode = async (payload) => {
  const { data } = await apiClient.post("/barcode/", payload);

  return data;
};
